export default __webpack_public_path__ + "static/media/onama2.f7b804d9.jpg";